module.exports = __webpack_public_path__ + "img/1.806a2ff4.png";